import Skeleton from '@passkeys/ui/skeleton';

const Item = () => (
  <div className="p-2 pb-4">
    <Skeleton width={150} height={150} borderRadius={14} />
    <div className="mt-2 flex w-full flex-col px-1">
      <div className="flex items-center justify-between">
        <Skeleton width={80} height={20} />
        <Skeleton width={20} height={20} shape="circle" />
      </div>
      <Skeleton width={90} height={16} className="mt-1" />
    </div>
  </div>
);

function Loading() {
  return (
    <div className="flex h-full flex-col items-center">
      <div className="grid grid-cols-2 gap-4">
        <Item />
        <Item />
        <Item />
        <Item />
      </div>
    </div>
  );
}

export default Loading;
